// Closing section: final call-to-action. Mounted once by Landing.tsx, last
// in the page. Carries data-mood="closing" so MoodAtmosphere retints the
// background here. The ClosingCube sits directly above the heading: the
// page's last mark, edges crawling, one face lit at a time in the same
// clockwise order "How we work" counts in. Its one-shot settle-in as the
// section arrives is markChoreography.ts's business (data-mark="closing-cube").
import { ClosingCube } from "../marks/ClosingCube";
import "./Closing.css";

// Small inline arrow glyph, same shape used by every other section's CTA.
const Arrow = () => (
  <svg className="arrow" width="14" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M1 5h11M8.5 1.5 12 5l-3.5 3.5" />
  </svg>
);

export function Closing() {
  return (
    <section className="section closing" data-mood="closing">
      <div className="wrap">
        {/* Grouped so the cube and heading move as one block; the cube stays
            stacked ABOVE the heading at every width (see Closing.css's
            <640px rule for the mobile size). */}
        <div className="closing__head">
          <ClosingCube />
          <h2>Got something that needs building?</h2>
        </div>
        <p>
          Tell us what is broken, or what is missing. We will tell you honestly whether
          we are the right people for it. We reply within a day.
        </p>
        <p className="closing__thesis">
          Two built, one building. Solid means shipped and running. Dashed means we're
          still on it.
        </p>
        <a className="btn" href="mailto:hello@blockworks.dev">
          hello@blockworks.dev <Arrow />
        </a>
      </div>
    </section>
  );
}
